
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import config from '../../config';
import { format } from 'date-fns';

import { useApi } from '../../ApiContext';
import { apiFetch } from '../utils/ApiFetch';

function MatchingSummary() {
  const navigate = useNavigate();
  const location = useLocation();
  const mongoId = location.state?.mongoId;
  const mrNumber = location.state?.mrNumber;
  const alertTitle = location.state?.alertTitle ;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { callApi, setIsApiLoading } = useApi();
  const username = sessionStorage.getItem("username");
  const mrToken = localStorage.getItem("mr_token");
  // Move fetchData outside of useEffect
  

  
  const handleBack = () => {
    const lastPage = sessionStorage.getItem('lastPage');
    navigate('/home', { state: { page: lastPage ? Number(lastPage) : 1 } });
  };
  const fetchData = async () => {
	await callApi(async () => {
		setIsApiLoading(true);
    try {
	      const response = await apiFetch(`${config.API_BASE_URL}/matchingsummary`, {
	        method: 'POST',
            headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
	        body: JSON.stringify({ "mongoId": mongoId }),
	      });
	
	      if (!response.ok) {
	        throw new Error('Failed to fetch data');
	      }
	
	      const result = await response.json();
	      const list = Array.isArray(result?.data) ? result.data : [];
	      setTableData(list);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
	  setIsApiLoading(false);
    }
	});
  };

  const doDraft = (batchMatchId, clientId, matchResultId) => {
    navigate('/matching/draftreview', { state: { batchMatchId, clientId , matchResultId, alertTitle} });
  };

  const doFinal = (batchMatchId, clientId) => {
	navigate('/matching/finalreview', { state: { batchMatchId, clientId } });
  };

  useEffect(() => {
    fetchData();
  }, [mongoId]);

  const handleRefresh = () => {
    fetchData(); // Now fetchData is accessible here
  };
  

  // Add this above your component's return
  const reSubmit = (batchMatchId, clientId) => {
    // To be implemented
  };


  if (loading) {
    return <div>Loading...</div>;
  }

 
  const pickCount = (row, baseKey) => {
    const useDateFilter = row?.dateFilter === 'ON';
    const key = useDateFilter ? `${baseKey}Df` : baseKey;
    return row?.[key] ?? 0;
  };

 

  return (
    <>
      <Header />
      <div className="container-fluid text-secondary">
        <br />
        <br />
        <br />
        <br />
        <div className="container-fluid no-margin no-padding text-secondary">
        <div className="card text-secondary">
                     
					 <div className="card-header d-flex justify-content-between align-items-center">
	 				    <span>
	 				      <span className="pointer-cursor" 
	 					  title={`Back to matching summary (page ${sessionStorage.getItem('lastPage')})`}
	 					  onClick={handleBack}>Home</span> <i className="fa fa-arrow-right"></i> Matching Summary
	 				    </span>
	 				    <button
	 				      id="back_summary_btn"
	 				      type="button"
	 				      className="btn btn-sm btn-secondary"
	 				      onClick={handleBack}
	 					  title={`Back to matching summary (page ${sessionStorage.getItem('lastPage')})`}
	 				    >
	 				      Back to Home
	 				    </button>
	 				  </div>
					 
                     <div className='card-body  custom-card-bg'>
          <div className="card">
            <div className="card-header text-secondary">Matching Summary - {mrNumber}</div>
            <div className="card-body">
			<div class="alert alert-success" role="alert">
			  <h4 class="alert-heading">MR Number - {mrNumber}</h4>
			  <p>Alert Title: {alertTitle}
			  </p>
			</div>

              <div className="table-responsive">
                <table className="table table-responsive-sm text-secondary table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th className="pointer-cursor">#</th>
                      <th>Action</th>
                      <th className="text-nowrap">MR Number</th>
                      <th className="text-nowrap">Client ID</th>
                      <th className="text-nowrap">Client Name</th>
                      <th className="text-nowrap">Status</th>
                      <th className="text-nowrap">Lvl 1</th>
                      <th className="text-nowrap">Lvl 2</th>
                      <th className="text-nowrap">Lvl 3</th>
                      <th className="text-nowrap">Lvl 4</th>
                      <th className="text-nowrap">Lvl 5</th>
                      <th className="text-nowrap">Batch Dt</th>
                      <th className="text-nowrap">Draft Review</th>
                      <th className="text-nowrap">Draft Dt</th>
                      <th className="text-nowrap">Final Review</th>
                      <th className="text-nowrap">Final Dt</th>

                    </tr>
                  </thead>
                  <tbody>
                    {tableData.length === 0 ? (
                      <tr>
                        <td colSpan={11} className="text-center">No data found</td>
                      </tr>
                    ) : (
                      tableData.map((row, idx) => (
                        <tr key={row.mongoId || idx}>
                          <td>{idx + 1}</td>

						  <td style={{ minWidth: '145px' }}>
						    <select
						      className="form-select form-select-sm"
						      defaultValue=""
							  onChange={e => {
							    const action = e.target.value;
							    if (action === "draft") doDraft(String(row.batchMatchId), row.clientId, row.matchResultId);
							    else if (action === "final") doFinal(String(row.batchMatchId), row.clientId);
							    else if (action === "resubmit") reSubmit(String(row.batchMatchId), row.clientId);
							    e.target.value = ""; // Reset dropdown after action
							  }}
						    >
						      <option value="" disabled>Select Action</option>
						      <option value="draft">Draft Review</option>
						      <option value="final">Final Review</option>
						      <option value="resubmit">Resubmit</option>
						    </select>
						  </td>

                          <td className="text-nowrap">
						  <a
						    href="#"
						    
						    onClick={(e) => {
						      e.preventDefault();
						      doDraft(String(row.batchMatchId), row.clientId, row.matchResultId);
						    }}
						  >
						    {row.mrNumber}
						  </a>

						  </td>
                          <td>{row.clientId}</td>
                          <td className="text-nowrap">{row.clientName}</td>
                          <td className={
                            row.status === 'BATCH_SUBMITTED' ? 'text-danger' :
                              row.status === 'BATCH_COMPLETED' ? 'text-warning' :
                                row.status === 'DRAFT_REVIEW_DONE' ? 'text-info' :
                                  row.status === 'FINAL_REVIEW_DONE' ? 'text-success' :
                                    row.status === 'BATCH_RESUBMITTED' ? 'text-primary' : 'text-danger'
                          }>{row.status}</td>
						  
						   <td>{pickCount(row, 'count1a')}</td>
						   <td>{pickCount(row, 'count2a')}</td>
						   <td>{pickCount(row, 'count2b')}</td>
						   <td>{pickCount(row, 'count2c')}</td>
						   <td>{pickCount(row, 'count3a')}</td>
                          <td className="text-nowrap">{row.batchRunTimeStamp ? format(new Date(row.batchRunTimeStamp), 'M/dd/yyyy hh:mm a') : ''}</td>
                          <td className="text-nowrap">{row.draftReviewBy}</td>
                          <td className="text-nowrap">{row.draftReviewTimestamp ? format(new Date(row.draftReviewTimestamp), 'M/dd/yyyy hh:mm a') : ''}</td>
                          <td className="text-nowrap">{row.finalReviewBy}</td>
                          <td className="text-nowrap">{row.finalReviewTimestamp ? format(new Date(row.finalReviewTimestamp), 'M/dd/yyyy hh:mm a') : ''}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div></div>
      <Footer />
    </>
  );
}

export default MatchingSummary;
